import { Box, Checkbox, IconButton, TableCell, TableRow } from "@mui/material";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/EditIcon.svg";
import { admin, noneValue, superAdmin } from "../../constants/constants";
import { projectService } from "../../core/models/projectServiceModel";
import { PurchaseDTO } from "../../core/models/purchaseModelDTO";
import { openEditDialog } from "../../core/state/dialogs/editPurchaseDialogSlice";
import { openRemoveDialog } from "../../core/state/dialogs/removePurchaseDialogSlice";
import { useAppDispatch, useAppSelector } from "../../core/state/hooks";

export default function PurchaseRow(props: { services: Array<projectService>, purchase: PurchaseDTO, visibility: string, isChecked: boolean, option: number, handleOnChange: (event: any) => void }) {
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.user);
    
    const getPurchaseDate = (date: Date): string => {
        const stringDateArray = date.toString().split("-");
        return `${(stringDateArray[2]).split('T')[0]}/${stringDateArray[1]}/${stringDateArray[0]}`
    }

    return (

        <TableRow hover role="checkbox" tabIndex={-1} sx={{ maxHeight: '50px' }} >
            {/* Checkbox */}
            <TableCell align="right" sx={{ p: 0 }}>
                <Checkbox
                    id={`1`}
                    sx={{ display: props.visibility === noneValue ? noneValue : '', p: 0, }}
                    checked={props.isChecked}
                    onChange={props.handleOnChange}
                    value={props.option}
                    inputProps={{
                        'aria-labelledby': "labelId",
                    }}
                />
            </TableCell>

            {/* Resto de las columnas */}
            <TableCell align="center">{getPurchaseDate(props.purchase.date)}</TableCell>
            <TableCell align="center">{props.purchase.document.length > 30 ? `${props.purchase.document.slice(0, 30)}...` : props.purchase.document}</TableCell>
            <TableCell align="center">{props.purchase.supplier.length > 30 ? `${props.purchase.supplier.slice(0, 30)}...` : props.purchase.supplier}</TableCell>
            <TableCell align="center">{props.purchase.rut.length > 30 ? `${props.purchase.rut.slice(0, 30)}...` : props.purchase.rut}</TableCell>
            <TableCell align="center">{props.purchase.sector}</TableCell>
            <TableCell align="center">{props.purchase.subSector}</TableCell>
            <TableCell align="center">{props.purchase.concept.length > 23 ? `${props.purchase.concept.slice(0, 23)}...` : props.purchase.concept}</TableCell>
            <TableCell align="center">{props.purchase.service ? (props.purchase.service.length > 26 ? `${props.purchase.service.slice(0, 25)}...` : props.purchase.service) : null}</TableCell>
            <TableCell align="center">{props.purchase.projectCode}</TableCell>
            <TableCell align="center">{props.purchase.currency}</TableCell>
            <TableCell align="center">{props.purchase.netOrigin.toString().length > 10 ? `${props.purchase.netOrigin.toString().slice(0, 10)}...` : props.purchase.netOrigin.toString()}</TableCell>
            <TableCell align="center">{props.purchase.tax ? (props.purchase.tax.toString().length > 10 ? `${props.purchase.tax.toString().slice(0, 10)}...` : props.purchase.tax.toString()) : ''}</TableCell>
            <TableCell align="center">{props.purchase.total ? (props.purchase.total.toString().length > 10 ? `${props.purchase.total.toString().slice(0, 10)}...` : props.purchase.total.toString()) : ''}</TableCell>
            {/* Columna de Acciones (al final, sticky derecha) */}
            <TableCell align="center" sx={{ p: 0.5, paddingLeft:'50px !important' , paddingRight:'20px !important', position: 'sticky', right: 0, backgroundColor: 'white', zIndex: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
                    {(user.appRoleId === admin || user.appRoleId === superAdmin) ? (
                        <>
                            <IconButton
                                onClick={() => dispatch(openEditDialog(props.purchase))}
                                size="small"
                                children={<EditIcon />}
                            />
                            <IconButton
                                onClick={() => dispatch(openRemoveDialog(props.purchase.id))}
                                size="small"
                                children={<DeleteIcon />}
                            />
                        </>
                    ) : null}
                </Box>
            </TableCell>
        </TableRow>
    )
}